import { render } from "./BannerPromocionalPrincipal.vue?vue&type=template&id=f6ce99f8"
import script from "./BannerPromocionalPrincipal.vue?vue&type=script&lang=js"
export * from "./BannerPromocionalPrincipal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__